import { Animate, Loader, useAPI, usePlans } from 'components/lib'
import ChangePlan from './ChangePlan'
import YourPlan from './YourPlan'
import { BillingNav } from 'components/nav/sub/billing'

export default function Plans() {
  const { data: subscription, loading: loadingSubscription } = useAPI('/api/account/subscription')
  const { data: plans, loading: loadingPlans } = usePlans()

  if (!subscription || loadingSubscription || !plans || loadingPlans) return <Loader />

  return (
    <div className=' h-full overflow-y-auto'>
      <BillingNav />

      <Animate>
        <div className='bg-brand-accent-light-flat'>
          <YourPlan subscription={subscription} plans={plans} />
        </div>
        <ChangePlan subscription={subscription} plans={plans} />
      </Animate>
    </div>
  )
}
